
        var result = require("!!../../../../node_modules/css-loader/index.js!./group-list.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/group-list/group-list.component.css
// module id = 597
// module chunks = 0